import { faLongArrowAltLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC } from "react";

import styles from "./addableSynonym.module.scss";

type TAddableSynonymProps = {
    synonym: string,
    onAdd: (synonymText: string) => void
}

export const AddableSynonym: FC<TAddableSynonymProps> = ({ synonym, onAdd }: TAddableSynonymProps) => {

    const onClickAddSynonym = () => {
        onAdd(synonym);
    };

    return (
        <div className={styles.addableSynonym} title="Add as synonym" onClick={onClickAddSynonym}>
            <FontAwesomeIcon icon={faLongArrowAltLeft} />
            <span>{synonym}</span>
        </div>
    );
};